














import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper
    },
    data: function() {
        return {
            pathInStore: "property.building.facadeCount"
        };
    },
    computed: {
        facadeCount: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isOptional: function(): boolean {
            const mandatoryPropertyTypes: Array<string> = ["HOUSE"];

            return mandatoryPropertyTypes.indexOf(this.getPropertyType()) === -1;
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    methods: {
        updateValue: function(facadeCount: number): void {
            if (facadeCount == 0 && this.$store.getters["FormModule/getValue"](this.pathInStore) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": facadeCount});
            }
        }
    }
});

